import React, {useEffect} from "react";
import { motion } from "framer-motion";

const ErrorPage=()=>{
    const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(12px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

useEffect(() => {
    document.title =
      "Page Not Found | ONBBITS";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "The page you're looking for doesn't exist or has been moved. Explore ONBBITS WhatsApp automation solutions or return to the homepage to get back on track."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/404");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Page Not Found | ONBBITS"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "The page you're looking for doesn't exist or has been moved. Explore ONBBITS WhatsApp automation solutions or return to the homepage to get back on track."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/404");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Page Not Found | ONBBITS"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "The page you're looking for doesn't exist or has been moved. Explore ONBBITS WhatsApp automation solutions or return to the homepage to get back on track."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }
  }, [])

    return(
        <>
        <section className="not-found-section container hero">
             <motion.div
          className="hero-content"
          variants={container}
          initial="hidden"
          animate="visible"
        >

          <motion.h1 variants={fadeUp}>
           <span>404</span>
            <br />
            Oops! Page <span> Not Found.</span>
          </motion.h1>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            The link you followed might be broken, or the page may have been removed. Don't worry, let's get you back to growing your business.
          </motion.p>
          <motion.div
              whileHover={{
                y: -5,
                scale: 1.04,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                type: "spring",
                stiffness: 350,
                damping: 18,
              }}
            >
              <a href="/" className="btn btn-primary">
                Go Back to Home page
              </a>
            </motion.div>
          </motion.div>
        </section>
        </>
    )
}
export default ErrorPage;